import { useEffect, useRef } from "react";
import { motion, useInView, useMotionValue, useTransform, animate } from "framer-motion";

const AnimatedCounter = ({ from = 0, to = 100, suffix = "", duration = 1.6 }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-40px" });
    const mv = useMotionValue(from);
    const display = useTransform(mv, (v) => `${Math.round(v)}${suffix}`);
    useEffect(() => {
        if (inView) {
            const controls = animate(mv, to, { duration, ease: [0.22, 1, 0.36, 1] });
            return () => controls.stop();
        }
    }, [inView, mv, to, duration]);
    return <motion.span ref={ref}>{display}</motion.span>;
};

export default AnimatedCounter;
